import React from 'react';
import { Container, ContainerProps } from '@chakra-ui/react';

interface ChakraScrollableContainerProps extends ContainerProps {
  className?: string;
}

export const ChakraScrollableContainer: React.FC<ChakraScrollableContainerProps> = ({
  children,
  ...rest
}) => (
  <Container
    display="flex"
    height="100%"
    width="100%"
    overflowX="hidden"
    overflowY="visible"
    {...rest}
  >
    {children}
  </Container>
);
